import { useCommonReducer } from '@components/Shared/State/hooks';
import { GetAccountSettings } from '@themes/common/data';
const { customers_account_title } = GetAccountSettings().translations;
const useBreadcrumbs = () => useCommonReducer('ACCOUNT_BREADCRUMBS', {
    mainLink: {
        text: customers_account_title,
        href: '/account',
    },
    extraLinks: [],
    backLink: null,
});
export default useBreadcrumbs;
